export function timeFormat(fmt) {
	var date = new Date(fmt * 1000) //如果date为13位不需要乘1000
	var Y = date.getFullYear() + '-'
	var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
	var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
	var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
	var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
	var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
	return Y + M + D + h + m + s
}
export function isSex(sex) {
	if (sex == 0 || !sex) return '保密'
	if (sex == 1) return '男'
	if (sex == 2) return '女'
}
export function isImportant(l) {
	if (l == 0) return '普通'
	if (l == 1) return '一般'
	if (l == 2) return '重要'
	if (l == 3) return '非常重要'
}

export function typeText(type) {
	if (type == 1) return '孤儿'
	if (type == 2) return '事实无人抚养儿童'
	if (type == 3) return '留守儿童'
	if (type == 4) return '低保儿童'
	if (type == 5) return '特困儿童'
}

export function service_audit_status(l) {
	if (l == 0) return '未审核'
	if (l == 1) return '合格'
	if (l == 2) return '不合格'
	if (l == 3) return '终审不合格'
	if (l == 4) return '预审合格'
}
export function time(num) {
	if (num < 60) {
		return parseInt(num) + '分钟'
	} else {
		return parseInt(num / 60) + '小时' + (num % 60).toFixed(0) + '分钟'
	}
}
export function project_name(str) {
	// 根据不同的域名显示不同的项目名称
	const isChild = window.location.host.indexOf("childks") > -1;
	if (str) {
		str += isChild ? ',心理健康评估,家庭监护能力评估,安全教育宣传' : ',日常关怀慰问,排查安全隐患,普及生活常识'
		str = str.split(',')
		str = [...new Set(str)]
		str = str.join(',')
		return str
	} else return ''
}
export function fileName(str) {
	if (str) {
    let lastInx = str.lastIndexOf('/') + 1;
    let name = str.slice(lastInx, str.length);
		return name
	} else return ''
}

export function publish_type(str) {
	if (str) {
    if(str == 'internal') return '站内信'
    else if(str == 'push') return '手机app'
    else if(str == 'message') return '短信推送'
	} else return ''
}

export function user_type(str) {
	if (str) {
    if(str == 'community') return '社工'
    else if(str == 'admin') return '后台管理员'
    else if(str == 'volunteer') return '志愿者'
    else if(str == 'ordinary') return '普通用户'
	} else return ''
}

export function activity_type(str) {
	if (str) {
    if(str == 'center') return '活动中心'
    else if(str == 'volunteer') return '志愿者招募'
	} else return ''
}
